export const FETCH_TEAM_ASYNC = 'FETCH_TEAM_ASYNC';
export const FETCH_TEAM_COMPLETE = 'FETCH_TEAM_COMPLETE';
export const ADD_TEAM_MEMBER_ASYNC = 'ADD_TEAM_MEMBER_ASYNC';
export const ADD_TEAM_MEMBER_COMPLETE = 'ADD_TEAM_MEMBER_COMPLETE';
export const EDIT_TEAM_MEMBER_ASYNC = 'EDIT_TEAM_MEMBER_ASYNC';
export const EDIT_TEAM_MEMBER_COMPLETE = 'EDIT_TEAM_MEMBER_COMPLETE';
export const DELETE_TEAM_MEMBER_ASYNC = 'DELETE_TEAM_MEMBER_ASYNC';
export const DELETE_TEAM_MEMBER_COMPLETE = 'DELETE_TEAM_MEMBER_COMPLETE';
export const SELECT_TEAM_MEMBER = 'SELECT_TEAM_MEMBER';
export const SUSPEND_TEAM_MEMBER_ASYNC = 'SUSPEND_TEAM_MEMBER_ASYNC';
export const SUSPEND_TEAM_MEMBER = 'SUSPEND_TEAM_MEMBER';
export const ACTIVATE_TEAM_MEMBER_ASYNC = 'ACTIVATE_TEAM_MEMBER_ASYNC';
export const ACTIVATE_TEAM_MEMBER = 'ACTIVATE_TEAM_MEMBER';
export const FETCH_TEAM_ASYNC_END = 'FETCH_TEAM_ASYNC_END';
